import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.OperationResultPopup', {
    ApprovedBadge: 'Approved',
    approvedTitle: 'You have approved{br}{requestName}',
    rejectedBadge: 'Rejected',
    rejectedTitle: 'You have rejected{br}{requestName}',
    closeButtonText: 'Close',
    requestNotFoundTitle: 'The request was not found.',
    requestNotFoundDescription: 'Please check that you are logged in with the appropriate email address.',
    logoutButtonText: 'Log out',
    generalFailureDescription: `You're welcome to take a look at the request's audit log for more information.`,
    externallyUpdatedTitle: `Request can't be approved since it has been updated.`,
    notApproverTitle: 'You are no longer an approver of this request.',
    closedApprovedTitle: 'Request has already been approved',
    closedRejectedTitle: 'Request has already been rejected',
    cancelledTitle: 'Request has already been cancelled',
    alreadyApprovedTitle: 'You have already approved this request.',
    alreadyRejectedTitle: 'You have already rejected this request.',
    stepNotStartedTitle: 'Approval workflow has been restarted.',
    stepDoneTitle: '{user} has already approved this request.',
    requiresEditingTitle: `Request can't be approved since it requires review and coding.`,
    hasMatchingErrorTitle: 'The request cannot be approved because of a problem with the Bill-to-PO matching.',
    hasMatchingOverbudgetErrorTitle:
        'This Bill cannot get approved because the balance of the matched Purchase Orders is exceeded',
    hasMatchingOverbudgetErrorDescription:
        'Please edit the amounts allocated during the Bill-to-PO matching to eliminate any excess for the Purchase Order balance',
    hasMatchingExcessPOBalanceErrorTitle: `This Bill can't be approved as the balance of the matched PO(s) is exceeded`,
    hasMatchingExcessPOBalanceErrorDescription:
        'Please edit the allocated amounts in the Bill matching to eliminate the excess PO balance',
    openMatchingPopupButtonText: 'Edit matching',
});
